/* Pure state, shared by the theme custom element and Node acceptance tests. */
(function (root) {
  'use strict';
  class Routine {
    constructor(config) { this.config = config; this.reset(); }
    reset() { this.stage = 'intro'; this.hair = null; this.goal = null; this.base = []; this.extras = []; this.included = {}; this.variants = {}; }
    product(id) { return this.config.products[id]; }
    available(id) { const p = this.product(id); return Boolean(p && !p.requiresPlan && p.variants.some(v => v.available)); }
    initialize(id) {
      const p = this.product(id); if (!p) return;
      if (!(id in this.included)) this.included[id] = this.available(id) && !(this.config.cartProducts || []).includes(id);
      if (!(id in this.variants)) {
        const configured = p.variants.find(v => p.defaultVariant && v.available && (v.id === p.defaultVariant || v.title === p.defaultVariant));
        this.variants[id] = configured?.id || (p.variants.length === 1 && p.variants[0].available ? p.variants[0].id : '');
      }
    }
    chooseHair(key) {
      const option = this.config.hair.find(x => x.key === key); if (!option) return false;
      this.hair = key; this.base = option.base.filter(id => this.product(id));
      this.base.forEach(id => this.initialize(id)); this.stage = 'goal'; return true;
    }
    chooseGoal(key) { if (!this.config.goals.some(x => x.key === key)) return false; this.goal = key; this.stage = 'recommend'; this.initialize(this.recommended()); return true; }
    recommended() { return this.config.rules.find(x => x.hair === this.hair && x.goal === this.goal)?.product || this.config.goals.find(x => x.key === this.goal)?.product; }
    accept() { const id = this.recommended(); if (!this.available(id)) return false; if (!this.base.includes(id) && !this.extras.includes(id)) this.extras.push(id); this.initialize(id); this.included[id] = !(this.config.cartProducts || []).includes(id); this.stage = 'result'; return true; }
    skip() { this.stage = 'result'; }
    back() { this.stage = ({ goal: 'hair', recommend: 'goal', result: 'goal' })[this.stage] || 'hair'; }
    toggle(id, value) { if (this.product(id)) this.included[id] = Boolean(value) && this.available(id); }
    setVariant(id, variantId) { if (variantId === '' && this.product(id)) { this.variants[id] = ''; return true; } const v = this.product(id)?.variants.find(x => x.id === variantId && x.available); if (!v) return false; this.variants[id] = v.id; return true; }
    entries() { return [...new Set([...this.base, ...this.extras])].filter(id => this.product(id)).map(id => ({product: this.product(id), included: this.included[id], variant: this.product(id).variants.find(v => v.id === this.variants[id])})).sort((a,b) => a.product.order - b.product.order); }
    cart() {
      const selected = this.entries().filter(x => x.included); const items = []; let total = 0; let ready = selected.length > 0;
      selected.forEach(({product,variant}) => {
        if (!variant?.available || product.requiresPlan) { ready = false; return; }
        const quantity = Math.max(1, Number(variant.min) || 1);
        if (variant.max && quantity > variant.max) { ready = false; return; }
        items.push({ id: variant.id, quantity }); total += variant.price * quantity;
      });
      return {ready,items,total};
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {Routine};
  else root.ParkPDPRoutineState = {Routine};
})(typeof window !== 'undefined' ? window : globalThis);
